<template>
  <v-container class="app-page-container">
    <div v-if="getTaskChangeVisibility">{{changeVisibility()}}</div>
    <div v-if="getAxiosRefresh == 1">{{readTaskData()}}</div>
    <div v-if="need_init && getLanguageIcons && user">{{initData()}}</div>
    
      <v-card class="shadow-none app-page-card">
            <v-layout wrap>              
              <v-flex xs12>
                <v-card v-if="access_denied" class="shadow-none">
                  <v-card-text>
                      <v-layout align-center>
                        <h1>You don't have a permission to edit this content.</h1>
                      </v-layout>
                  </v-card-text>
                </v-card>

                <v-card v-if="!access_denied && prepared" class="shadow-none">
                  <v-card-text v-if="myContent.id > 0 && !myContent.islocked" class="border-b pa-0">
                      <CountDown />
                  </v-card-text>
                  <v-card-text v-if="myContent.islocked">
                     <v-icon v-if="myContent.islocked" color="primary">lock</v-icon>
                  </v-card-text>
                  <!-- languages -->
                  <div>
                    <v-layout class="pa-2">
                        <v-flex class="language__translator-group language__translator-group--labelless vertically-horizontally-centered flex-grow-0" >
                            <v-icon :class="['material-icons-outlined card-border-style rounded mr-2', ($store.getters.getTaskVertic == false) ? 'active-border-style active-color':'']" title="change to vertical view" @click="$store.commit('setTaskVertic', false)">vertical_split</v-icon>
                            <v-icon :class="['material-icons-outlined card-border-style rounded', ($store.getters.getTaskVertic == true) ? 'active-border-style active-color':'']" title="change to horizontal view" @click="$store.commit('setTaskVertic', true)">horizontal_split</v-icon>
                        </v-flex>
                        <v-flex class="language__translator-group vertically-horizontally-centered flex-grow-1" data-title="translated (click to show)">
                            <span v-for="(language,index) in myContent.languages" :key=index class="translator-group__item">
                                <img v-if="language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.lang_id-1].url"
                                :title='getLanguageIcons[language.lang_id-1].title'  
                                @click ="$store.commit('setShowTaskIndex',index)"
                                />
                            </span>    
                        </v-flex>
                        <v-flex class="language__translator-group vertically-horizontally-centered flex-grow-1" data-title="not translated (click to edit)">
                            <span v-for="(language,index) in myContent.languages" :key=index class="translator-group__item">
                                <img v-if="!language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.lang_id-1].url"
                                    :title='getLanguageIcons[language.lang_id-1].title' 
                                    @click ="$store.commit('setTaskPreparedEdit',index)"
                                    :style="getCursorPermission(index)"
                                />
                            </span>  
                        </v-flex> 
                      </v-layout>
                    
                      <!-- tasks -->                  
                      <EType1 v-if="$route.params.id_type == 1" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                      <EType234 v-if="$route.params.id_type == 2 ||$route.params.id_type == 3 || $route.params.id_type == 4" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                      <EType56 v-if="$route.params.id_type == 5 ||$route.params.id_type == 6" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                      <EType7 v-if="$route.params.id_type == 7" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                      <EType8910 v-if="$route.params.id_type == 8 ||$route.params.id_type == 9 ||$route.params.id_type == 10" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />

                      <ExType01 v-if="$route.params.id_type == 12" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                      <ExType02 v-if="$route.params.id_type == 13 || $route.params.id_type == 14 || $route.params.id_type == 15" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                      <ExTypeEs v-if="$route.params.id_type == 16" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                      <ExTypeGen v-if="$route.params.id_type == 17" v-bind:my_element = 'myContent' v-bind:objectChangePermission = 'objectChangePermission' />
                  </div>
                </v-card>                  
                
                 
              </v-flex>
          </v-layout>
      </v-card>
  </v-container>
</template>


<script>
import axios from '../../../axios-auth'
import {mapGetters} from 'vuex'
import EType1 from './equestion_types/etype1.vue'
import EType234 from './equestion_types/etype234.vue'
import EType56 from './equestion_types/etype56.vue'
import EType7 from './equestion_types/etype7.vue'
import EType8910 from './equestion_types/etype8910.vue'
import ExType01 from './equestion_types/extype1.vue'
import ExType02 from './equestion_types/extype234.vue'
import ExTypeEs from './equestion_types/extypeEs.vue'
import ExTypeGen from './equestion_types/extypeGen.vue'
import CountDown from '../../../components/misc/CountDown.vue'
   

  export default {
    data() {
      return {
        content: [],
        access_denied: false,
        need_init : false,
        prepared : false,
        systemPermissions: null,
        objectChangePermission: false,
      }
    },
    computed: 
        mapGetters([
                        'getShowModalMessageResult',
                        'getLanguageIcons',
                        'user',
                        'getShowTaskIndex',
                        'getEditTaskIndex',
                        'getTaskVertic',
                        'getTaskChangeVisibility',
                        'getAxiosRefresh'
                    ])
    ,
    mounted () {
      this.need_init = true
      this.prepared = false
    },
    beforeDestroy() {
      if (this.myContent.id == 0) return
      const data = { task_id: this.myContent.id}
      axios.post('/unlock-task', data, this.$store.getters.getAxiosConfig)
      .then(() => {          
      })
      .catch(error => {
          this.$store.commit('setFeedback', error)
      })
    },

    components :{
      CountDown,
      EType1,
      EType234,
      EType56,
      EType7,
      EType8910,
      ExType01,
      ExType02,
      ExTypeEs,
      ExTypeGen
    },
    
   methods: { 
    initData() {        
      this.need_init = false     
      this.systemPermissions = this.$store.getters.getSystemPermissions      
        
      this.$store.commit('setShowTaskIndex', this.$route.params.show_lang)
      this.$store.commit('setEditTaskIndex',this.$route.params.edit_lang)
      
      if (this.$route.params.id == '0') {          
        const _element = {
          id: 0,
          task_type_id: this.$route.params.id_type,
          islocked: false,
          lck_user: 0,
          locked: 0,
          max_score: 0,
          task_order: 0,
          globals: '',
          translations : []      
        }
        this.prepareContent(_element)
        this.objectChangePermission = true
        this.prepared = true 
      } else { // if (this.$route.params.id != '0') {
          this.readTaskData()
      }
    },
    readTaskData() {
      this.$store.commit('setAxiosRefresh', 2) // updating
      const _data = { lang_id : this.getLanguageIcons[this.$route.params.edit_lang].id } 
      axios.post('/get-task/' + this.$route.params.id, _data, this.$store.getters.getAxiosConfig)
        .then(res => {
            this.content = res.data
            const bc = [
                { text: res.data.brc.category.name, href: '/areas/' + res.data.brc.category.id },//#
                { text: res.data.brc.area.name, href: '/courses/' + res.data.brc.area.id }, //#             
                    { text: res.data.brc.course.name + ' (user)', href: '/course_content/' + res.data.brc.course.id }, //#
                    { text: res.data.brc.course.name + ' (edit)', href: '/edit_chapters/' + res.data.brc.course.id }, //#
                { text: res.data.brc.chapter.name, href: '/edit_lessons/' + res.data.brc.chapter.id }, //#
                { text: res.data.brc.lesson.name, href: '/task_list/' + res.data.brc.lesson.id }, //#
            ]                            
            this.$store.commit('setBreadCrumbs',bc) 
            if (res.data.message != 'OK' || res.data.element_list.length != 1) {
              this.access_denied = true                  
              this.prepared = true
            } else {                            
              this.prepareContent(res.data.element_list[0])
            }  
            if (this.$route.params.id_type != this.myContent.task_type_id) {
              this.access_denied = true
              return
            }
            this.prepared = true                 
            this.objectChangePermission = 
                (this.content.permissions.list[0].role_code >= this.$store.getters.getSystemPermissions.course_content_creator) 
                || (this.content.permissions.list[0].role_code == this.$store.getters.getSystemPermissions.chapter_content_creator)     
            this.$store.commit('setCountdownStatus', { id: this.$route.params.id, count: 1800, max: 1800})                           
            this.$store.commit('setAxiosRefresh', 3) // update-refresh component inside
      })
      .catch(error => {
          this.$store.commit('setFeedback', error)
      })
    },   
    prepareContent(_element) { // creates full record of task with all languages
        this.myContent = {
            id: _element.id,
            task_type_id: _element.task_type_id,
            islocked: _element.islocked,
            lck_user: _element.lck_user,
            locked: _element.locked,
            max_score: _element.max_score,
            task_order: _element.task_order,
            globals: _element.globals,
            course_id: this.$route.params.course_id,
            lesson_id: this.$route.params.lesson_id, 
            languages : []      
        }                   
        if (this.myContent.islocked) this.$store.commit('setFeedback', 'The task is locked by another user <BR />- you can only read. <BR />To edit try again later.')           
        var j = 0
        for(let i = 0; i < this.getLanguageIcons.length; i++) {
            if (j >= _element.translations.length || _element.translations[j].lang_id != this.getLanguageIcons[i].id) {
                this.myContent.languages.push( {
                    lang_id: this.getLanguageIcons[i].id,
                    content: '',
                    visible: 1,
                    translated: false,
                    permissions: this.$route.params.id == '0' ? true : this.getPermissions(this.getLanguageIcons[i].id, this.content.brc.chapter.id)
                  }                  
                )                
            } else { // ==
                var _translated = _element.translations[j].content.length > 0 ? true : false
                if (_element.task_type_id >=2 && _element.task_type_id < 8)
                  _translated = JSON.parse(_element.translations[j].content).content.length > 0 ? true : false
                if (_element.task_type_id >=8 && _element.task_type_id < 12)
                  _translated = JSON.parse(_element.translations[j].content).title.length > 0 || JSON.parse(_element.translations[j].content).assignment.length > 0 ? true : false

                this.myContent.languages.push( {
                    lang_id: this.getLanguageIcons[i].id,
                    content: _element.translations[j].content,
                    visible: _element.translations[j].visible,
                    translated: _translated,
                    permissions: this.getPermissions(this.getLanguageIcons[i].id, this.content.brc.chapter.id)
                  }
                )
                j = j + 1
            }
        }
    },
    getPermissions(_lang_id, _chapter_id) {        
        if (this.content.permissions.list.length < 1) return false        
        for(let i = 0; i< this.content.permissions.list.length; i++) {
            if (this.content.permissions.list[i].role_code > 999) 
              return true
            if (this.content.permissions.list[i].role_code == this.systemPermissions.course_content_creator)
              return true
            if ((this.content.permissions.list[i].role_code == this.systemPermissions.course_content_translator)
               && (_lang_id == this.content.permissions.list[i].language_id))
              return true
            if ((this.content.permissions.list[i].role_code >= this.systemPermissions.chapter_content_translator)
                   && (_lang_id == this.content.permissions.list[i].language_id)
                   && (_chapter_id == this.content.permissions.list[i].sub_obj_id))
              return true
        }
        return false
    },
    getCursorPermission(_index) {
      if (this.myContent.languages[_index].permissions) return "cursor:pointer;"
      return "cursor:not-allowed;"
    },  
    changeVisibility() {
      this.$store.commit('setTaskChangeVisibility', false)
      const _data = {
          task_id: this.$route.params.id,
          visibility: this.$store.getters.getTaskNewVisibility,
          lang_id: parseInt(this.getShowTaskIndex) + 1,
      }
      axios.post('/change-task-visibility', _data, this.$store.getters.getAxiosConfig)
      .then(res => {
          if (res.data.message != 'OK') {
              this.$store.commit('setFeedback', res.data.message)
              return
          }                 
      })
      .catch(error => {
          this.$store.commit('setFeedback', error)
      })                         
    },
   }
  }
</script>
